export const navigateTo = (path) => ({
    type: 'NAVIGATE_TO',
    payload: path,
});
